import type { SxProps } from "@mui/material/styles";
import type { muiTheme } from "@polifonia/theme";
import { theme } from "@polifonia/theme";

/**
 * Shared by the header in `ApiKeyTable` and every `ApiKeyRow`. This repo has no
 * generic table component -- rows are composed from `Box`/`Stack`, so the
 * columns only line up as long as both sides read their widths from here.
 */
export const apiKeyTableStyles = {
  row: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  divider: {
    width: "100%",
    height: "1px",
    backgroundColor: theme.colors.neutral030,
  },
  colName: {
    flex: "0 0 28%",
    padding: "12px 16px 12px 8px",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  colKey: {
    flex: "0 0 22%",
    padding: "12px 8px",
    minWidth: 0,
    fontFamily: "monospace",
  },
  colStatus: {
    flex: "0 0 14%",
    padding: "12px 8px",
    minWidth: 0,
  },
  colCreatedAt: {
    flex: 1,
    padding: "12px 8px",
    minWidth: 0,
    whiteSpace: "nowrap",
  },
  colActions: {
    flex: "0 0 16%",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: 0,
    justifyContent: "flex-end",
  },
  actionButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px",
    border: `1px solid ${theme.colors.neutral030}`,
    borderRadius: "4px",
    background: "none",
    cursor: "pointer",
    color: theme.colors.staticFgNote,
    fontSize: "16px",
    "&:hover": {
      backgroundColor: theme.colors.staticBgPlain,
    },
    "&:disabled": {
      cursor: "default",
      color: theme.colors.staticFgDisable,
      opacity: 0.5,
    },
  },
  dangerActionButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px",
    border: `1px solid ${theme.colors.neutral030}`,
    borderRadius: "4px",
    background: "none",
    cursor: "pointer",
    color: theme.colors.staticFgNegative,
    fontSize: "16px",
    "&:hover": {
      backgroundColor: theme.colors.staticBgNegative,
    },
  },
} satisfies Record<string, SxProps<typeof muiTheme>>;
